import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  template: `
    <label class="checkbox-shell" [class.checkbox-shell--switch]="variant() === 'switch'">
      <input type="checkbox" [checked]="checked()" [attr.role]="variant() === 'switch' ? 'switch' : null"
        [attr.aria-label]="ariaLabel() || label()" (change)="checkedChange.emit(!checked())" />
      @if (variant() === 'switch') {
        <span class="switch-track" aria-hidden="true"></span>
      }
      @if (label()) {
        <span>{{ label() }}</span>
      }
    </label>
  `,
  styles: [
    `
      .checkbox-shell {
        display: inline-flex;
        align-items: center;
        gap: 8px;
      }

      .checkbox-shell span {
        font-size: 13px;
        color: var(--text);
      }

      .checkbox-shell--switch { position: relative; cursor: pointer; }
      .checkbox-shell--switch input {
        position: absolute;
        width: 36px;
        height: 20px;
        margin: 0;
        opacity: 0;
      }
      .switch-track {
        display: block;
        width: 36px;
        height: 20px;
        flex-shrink: 0;
        border-radius: 999px;
        background: var(--faint);
        transition: background var(--transition-fast);
      }
      .switch-track::after {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        margin: 2px;
        border-radius: 50%;
        background: var(--bg-surface);
        transition: transform var(--transition-fast);
      }
      input:checked + .switch-track { background: var(--accent); }
      input:checked + .switch-track::after { transform: translateX(16px); }
      input:focus-visible + .switch-track { outline: 2px solid var(--focus); outline-offset: 3px; }
      input:disabled + .switch-track { opacity: .5; cursor: not-allowed; }
      @media (prefers-reduced-motion: reduce) {
        .switch-track, .switch-track::after { transition: none; }
      }
    `,
  ],
})
export class CheckboxComponent {
  readonly checked = input<boolean>(false);
  readonly checkedChange = output<boolean>();
  readonly label = input<string>('Marcar');
  readonly ariaLabel = input<string>('');
  readonly variant = input<'checkbox' | 'switch'>('checkbox');
}
